import { UAParser } from "ua-parser-js";
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const MODEL = "model";
const NAME = "name";
const TYPE = "type";
const VENDOR = "vendor";
const VERSION = "version";
const MOBILE = "mobile";
const PLATFORM = "platform";
const GNB_VERIOSN = "gnb_version";
function mergeExtensions(regexes, extensions) {
  const mergedRegexes = {};
  for (const i in regexes) {
    mergedRegexes[i] = extensions[i] && extensions[i].length % 2 === 0 ? extensions[i].concat(regexes[i]) : regexes[i];
  }
  return mergedRegexes;
}
const BrowserName = {
  CHROME: "Chrome",
  EDGE: "Edge",
  SAFARI: "Safari",
  FIREFOX: "Firefox",
  OPERA: "Opera",
  MOBILE_CHROME: "Mobile Chrome",
  MOBILE_SAFARI: "Mobile Safari",
  MOBILE_FIREFOX: "Mobile Firefox",
  ANDROID_BROWSER: "Android Browser",
  WECHAT: "WeChat",
  ALIPAY: "Alipay",
  GAODING_APP: "gaoding-app",
  GAODING_PRO: "gaoding-pro"
};
const OSName = {
  WINDOWS: "Windows",
  LINUX: "Linux",
  MACOS: "macOS",
  IOS: "iOS",
  ANDROID: "Android"
};
const AppName = {
  GAODING_PRO: "gaoding-pro",
  GAODING_APP: "gaoding-app"
};
const DeviceType = {
  MOBILE: "mobile",
  TABLET: "tablet",
  SMARTTV: "smarttv",
  CONSOLE: "console",
  WEARABLE: "wearable",
  EMBEDDED: "embedded"
};
const customExtensions = {
  browser: [
    // gaoding app and gnb
    [/(?:ttxs|ttxs-dev|ttxs-fat|ttxs-stage)\/([\w.]+)\b.+GNB\/([\w.]+)/i],
    [VERSION, GNB_VERIOSN, [NAME, AppName.GAODING_APP], [TYPE, PLATFORM]],
    // gaoding app
    [/(?:ttxs|ttxs-dev|ttxs-fat|ttxs-stage)\/([\w.]+)/i],
    [VERSION, [NAME, AppName.GAODING_APP], [TYPE, PLATFORM]],
    // gaoding pro and gnb
    [/gaoding-pro\/([\w.]+)\b.+GNB\/([\w.]+)/i],
    [VERSION, GNB_VERIOSN, [NAME, AppName.GAODING_PRO], [TYPE, PLATFORM]],
    [/gaoding-pro\/([\w.]+)/i],
    [VERSION, [NAME, AppName.GAODING_PRO], [TYPE, PLATFORM]],
    [/alipayclient|alipaydefined/i],
    [[NAME, BrowserName.ALIPAY]]
  ],
  device: [
    // Vivo
    [/vivo ([\w.]+)/i],
    [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]],
    // Ximao
    [/Xiaomi ([\w.]+)/i],
    [MODEL, [VENDOR, "Xiaomi"], [TYPE, MOBILE]]
  ]
};
class UserAgentData {
  // 65.0.3325.181
  constructor({ userAgent, extensions = {}, headers }) {
    __publicField$1(this, "uaParser");
    __publicField$1(this, "os");
    __publicField$1(this, "os_version");
    __publicField$1(this, "device");
    __publicField$1(this, "model");
    __publicField$1(this, "app_name");
    __publicField$1(this, "app_version");
    __publicField$1(this, "gnb_version");
    __publicField$1(this, "browser");
    __publicField$1(this, "browser_version");
    this.uaParser = new UAParser(
      userAgent,
      mergeExtensions(customExtensions, extensions),
      headers
    );
    this.parse();
  }
  get ua() {
    return this.uaParser.getUA();
  }
  setUA(ua) {
    this.uaParser.setUA(ua);
    this.parse();
  }
  parse() {
    const { device, os, browser } = this.uaParser.getResult();
    if (device) {
      this.model = [device == null ? void 0 : device.vendor, device == null ? void 0 : device.model].filter((i) => i).join(" ");
      this.device = device == null ? void 0 : device.type;
    }
    if (os) {
      this.os = os == null ? void 0 : os.name;
      this.os_version = os == null ? void 0 : os.version;
    }
    if (browser) {
      this.browser = browser == null ? void 0 : browser.name;
      this.browser_version = browser == null ? void 0 : browser.version;
      if (browser.type === "platform") {
        this.app_name = browser.name;
        this.app_version = browser.version;
        this.gnb_version = browser.gnb_version;
      }
    }
  }
}
__publicField$1(UserAgentData, "enums", {
  BrowserName,
  AppName,
  OSName,
  Device: DeviceType
});
const resolvePlatformAdapter = (PlatformMapper, platform2) => {
  const getMatchedFunctor = (PlatformMapper2, matchMap) => {
    const matchKeys = Object.keys(matchMap).filter((key) => matchMap[key]);
    const removeISkeywords = (matchKey) => matchKey.replace(/^is/, "").replace(/^(.)/, (match) => match.toLowerCase());
    return matchKeys.map((matchKey) => {
      return PlatformMapper2[matchKey] || PlatformMapper2[removeISkeywords(matchKey)];
    }).find((i) => i);
  };
  return (...args) => {
    const {
      isGaodingIOSApp,
      isGaodingAndroidApp,
      isGaodingApp,
      isGaodingPro,
      isGaodingMacPro,
      isGaodingWindowPro,
      isWeApp,
      isWeAppWebview,
      isWechatWap,
      isWechat,
      isAlipay,
      isWeb,
      isWap
    } = platform2;
    const gradeOne = {
      isGaodingAndroidApp,
      androidApp: isGaodingAndroidApp,
      isGaodingIOSApp,
      iosApp: isGaodingIOSApp,
      isGaodingMacPro,
      isGaodingWindowPro,
      isWechatWap,
      wxWap: isWechatWap,
      isWeApp,
      isWeAppWebview
    };
    const gradeTwo = {
      isGaodingApp,
      isGaodingPro,
      app: isGaodingApp,
      isWechat,
      isAlipay
    };
    const gradeThree = {
      isWap,
      isWeb
    };
    const matchedFunctor = getMatchedFunctor(PlatformMapper, gradeOne) || getMatchedFunctor(PlatformMapper, gradeTwo) || getMatchedFunctor(PlatformMapper, gradeThree) || getMatchedFunctor(PlatformMapper, {
      default: true
    });
    if (typeof matchedFunctor === "function") {
      return matchedFunctor.apply(void 0, args);
    } else {
      console.error("必须传递一个函数");
    }
  };
};
const createAdapterFactory = (platform2) => {
  return (platformMapper) => {
    return resolvePlatformAdapter(platformMapper, platform2);
  };
};
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const platFormModuleMapper = {
  gaodingApp: async () => (await import("./app-57c83923.mjs")).default,
  gaodingPro: async () => (await import("./gaoding-pro-5f215024.mjs")).default,
  default: async () => {
  }
};
class Platform {
  constructor(platformOptions) {
    __publicField(this, "userAgentData");
    __publicField(this, "extend");
    __publicField(this, "adapter");
    __publicField(this, "resolveCurrentModuleAdapter");
    this.userAgentData = new UserAgentData(platformOptions);
    this.adapter = this.extend = createAdapterFactory(this);
    this.resolveCurrentModuleAdapter = this.extend(platFormModuleMapper);
  }
  getUAName() {
    var _a, _b;
    return (_b = (_a = this.userAgentData) == null ? void 0 : _a.ua) == null ? void 0 : _b.toLocaleLowerCase();
  }
  // 稿定 App => ttxs
  get isGaodingApp() {
    return this.userAgentData.app_name === UserAgentData.enums.AppName.GAODING_APP;
  }
  // 稿定新版桌面端
  get isGaodingPro() {
    return this.userAgentData.app_name === UserAgentData.enums.AppName.GAODING_PRO;
  }
  get isGaodingOldClient() {
    return /GaodingClient/i.test(this.getUAName()) || // 稿定旧客户端副窗口打开不会携带GaodingClient标识
    !this.isGaodingPro && /electron/i.test(this.getUAName());
  }
  // web 浏览器
  get isWeb() {
    return !this.isMobile && !this.isTablet && !this.isGaodingPro && !this.isGaodingApp;
  }
  // 手机端浏览器
  get isWap() {
    return this.isMobile && !this.isGaodingApp;
  }
  // 微信
  get isWechat() {
    return this.userAgentData.browser === UserAgentData.enums.BrowserName.WECHAT;
  }
  // 支付宝
  get isAlipay() {
    return this.userAgentData.browser === UserAgentData.enums.BrowserName.ALIPAY;
  }
  /**
   * 小程序
   * 小程序泛指各种小程序平台，不仅仅微信小程序（weAppWebview）
   */
  get isMiniProgram() {
    return /miniProgram/i.test(this.getUAName());
  }
  /**
   * 小程序 webview 泛指各种小程序平台，不仅仅微信小程序 webview
   */
  get isMiniProgramWebView() {
    return /miniprogramhtmlwebview/i.test(this.getUAName());
  }
  /**
   * 其他 ------------
   */
  // 手机端
  get isMobile() {
    return this.userAgentData.device === UserAgentData.enums.Device.MOBILE || /mobile/i.test(this.getUAName());
  }
  // pad 端
  get isTablet() {
    return this.userAgentData.device === UserAgentData.enums.Device.TABLET;
  }
  // iOS
  get isIOS() {
    return this.userAgentData.os === UserAgentData.enums.OSName.IOS || /iPhone|iPad/i.test(this.getUAName());
  }
  get isMac() {
    return this.userAgentData.os === UserAgentData.enums.OSName.MACOS;
  }
  get isWindows() {
    return this.userAgentData.os === UserAgentData.enums.OSName.WINDOWS;
  }
  // 安卓端
  get isAndroid() {
    return this.userAgentData.os === UserAgentData.enums.OSName.ANDROID;
  }
  // 稿定 App iOS
  get isGaodingIOSApp() {
    return this.isIOS && this.isGaodingApp;
  }
  // 稿定 App 安卓
  get isGaodingAndroidApp() {
    return this.isGaodingApp && !this.isIOS;
  }
  // 稿定 客户端 mac
  get isGaodingMacPro() {
    return this.isGaodingPro && this.isMac;
  }
  // 稿定 客户端 windows
  get isGaodingWindowPro() {
    return this.isGaodingPro && this.isWindows;
  }
  // 微信手机端浏览器
  get isWechatWap() {
    return this.isWechat && this.isMobile && !this.isMiniProgram;
  }
  // 微信小程序
  get isWeApp() {
    return this.isWechat && this.isMiniProgram && !this.isMiniProgramWebView;
  }
  get isWeAppWebview() {
    return this.isWechat && this.isMiniProgram && this.isMiniProgramWebView;
  }
  /**
   * 兼容历史，需要废弃
   */
  get isApp() {
    return this.isGaodingApp;
  }
  get isAndroidApp() {
    return this.isGaodingAndroidApp;
  }
  get isIosApp() {
    return this.isGaodingIOSApp;
  }
  get isWxWap() {
    return this.isWechatWap;
  }
}
const Platform$1 = Platform;
const isServive = typeof window === "undefined";
const platform = new Platform$1({
  userAgent: isServive ? "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7)" : window.navigator.userAgent
});
export {
  Platform$1 as default,
  platform
};
